import { AbstractDownloadableService } from "./abstract-downloadable.service";
import { Asset } from "../models";

/**
 * @class AssetPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<Asset>}
 */
export class AssetPmsApiService extends AbstractDownloadableService {
    
    static get $inject() {
        
        return super.$inject.concat(['Upload']);
    }
    
    constructor(http, config, eventsBroker, DownloadFile, Upload) {
        
        super(http, config, eventsBroker, DownloadFile);
        
        this.Upload = Upload;
    }
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/asset(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {Asset}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new Asset(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Asset>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Asset} furniture
     * @param {Property} property
     * @returns {Promise.<Asset>}
     */
    create(asset, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, asset.toObjectExcept('property', 'room_number', 'furniture_item', 'room_abbr', 'furniture_id', 'furniture_status', 'furniture_title', 'furniture_price', 'supplier_name'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Integer} propertyId
     * @param {Integer} assetId
     * @param {Object} params
     */
    show(propertyId, assetId, params = {}) {
        
        const url = this.url({
            propertyId: propertyId,
            id: assetId
        });

      return this.http
                 .get(url, {
                     headers: this.authHeaders,
                     params
                 })
                 .then(this.getModeler())
                 .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Asset} asset
     * @returns {Promise.<Asset>}
     */
    update(asset) {
        
        const url = this.url({
            propertyId: asset.property.id,
            id:         asset.id
        });
        
        return this.http
                   .put(url, asset.toObjectExcept('property', 'room_number', 'furniture_item', 'room_abbr', 'furniture_id', 'furniture_status', 'furniture_title', 'furniture_price', 'supplier_name'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Asset} asset
     * @returns {Promise.<boolean>}
     */
    delete(asset) {
        
        const url = this.url({
            propertyId: asset.property.id,
            id:         asset.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {File} document
     * @param {Property} property
     * @return {Promise.<Object>}
     */
    upload(document, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.Upload
                   .upload({
                       url: url + '/upload-document',
                       headers: this.authHeaders,
                       data: {document},
                   })
                   .then(this.getDataExtractor())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     */
    exportToExcel(params = {}, property = null) {
        
        const url = this.url({
            propertyId: property ? property.id : 0
        });
        
        return this.fetch(url + '/export-to-excel', 'Assets.xls');
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/asset.service.js